import { FC } from 'react';
import { Title } from '@mantine/core';

interface SubtitleProps {
    title: string;
    size?: 'huge' | 'big' | 'normal' | 'small';
    id?: string;
}

const Subtitle: FC<SubtitleProps> = ({ title, size, id }: SubtitleProps) => {
    let order: 1 | 2 | 3 | 4 | 5 | 6 = 3;

    switch (size) {
        case 'huge':
            order = 1;
            break;

        case 'big':
            order = 2;
            break;

        case 'normal':
            order = 3;
            break;

        case 'small':
            order = 4;
            break;
    }

    return (
        <Title order={order} style={{ paddingTop: 5, paddingBottom: 2, marginBottom: 20 }} id={id}>
            {title}
        </Title>
    );
};

export default Subtitle;
